import { z } from "../wire/zod";

export const createSessionResponseSchema = z.object({
  sessionId: z.string(),
  artId: z.number().int(),
  teamIds: z.array(z.number().int()),
});
export const getPresetResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  teams: z.array(z.object({ id: z.string(), name: z.string() })),
  iterations: z.array(z.object({ id: z.string(), name: z.string() })),
});
export const listPresetsResponseSchema = z.object({
  presets: z.array(z.object({ id: z.string(), name: z.string(), teams: z.array(z.string()) })),
});
